// extracted by mini-css-extract-plugin
export default {"form":"CancelarContrato_form__dlM3z","areaBtn":"CancelarContrato_areaBtn__RKfeu","btn":"CancelarContrato_btn__qfBR1"};